/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=a8f73138&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=a8f73138&lang=less"

import exportComponent from "/var/jenkins_home/workspace/online_group_vue_FE/code/enterpriseWeChat_sideBar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__